import React, { useState, useRef, useEffect } from "react";

const Accordion = () => {
  const faqs = [
    {
      question: "What type of AI Agents you develop?",
      answer:
        "We develop AI Agents that specialize in voice-based real estate assistance, appointment scheduling, lead generation, and multilingual customer care support.AI Agents are designed to enhance efficiency and improve customer satisfaction, ensuring seamless interactions and optimized workflows.",
    },
    {
      question: "How customizable are your AI Agents?",
      answer:
        "AI Agents are highly customizable to match your business needs. You can tailor their voice, tone, responses, and integrate them with your existing CRM or software systems.",
    },
    {
      question: "What industries can benefit from your AI Agents?",
      answer:
        "AI Agents are versatile and can be used in healthcare, retail, real estate, education, customer support, and many other industries.",
    },
    {
      question: "Are AI Agents secure for sensitive information?",
      answer:
        "Yes! AI Agents prioritize security, ensuring your sensitive information remains safe and protected.",
    },
    {
      question: "Can I track the performance of the AI Agent?",
      answer: "Yes! You can track performance by looking at logs, detailed analytics, and reports, including response times, customer satisfaction scores, and resolution rates."
    },
    
    {
      question: "Can AI Agents work in multiple languages?",
      answer:
        "Yes! AI Agents support multiple languages, allowing seamless communication with users from diverse backgrounds.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(null);
  const contentRefs = useRef([]);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    if (activeIndex !== null) {
      const activeContent = contentRefs.current[activeIndex];
      if (activeContent) {
        activeContent.style.maxHeight = `${activeContent.scrollHeight}px`;
      }
    }

    contentRefs.current.forEach((ref, index) => {
      if (index !== activeIndex && ref) {
        ref.style.maxHeight = "0px";
      }
    });
  }, [activeIndex]);

  return (
    <section>
      <div class="relative h-full">
        {/* <div class="absolute inset-0">
        <div class="absolute inset-0 z-0 h-full w-full items-center px-5 py-24 [background:radial-gradient(125%_120%_at_50%_10%,#000_40%,#210F49_100%)]"></div>
        </div> */}
        <div className="py-16 mt-20 md:py-20 mx-auto w-full max-w-6xl px-5 md:px-10 relative z-50">
          <div className="flex flex-col items-start lg:flex-row lg:space-x-20">
            <div className="lg:flex-[1_1_500px] w-full flex-none">
              <div className="max-w-3xl mb-8 md:mb-12 lg:mb-16">
                <h2 className="font-bold text-white text-3xl md:text-5xl">
                  General FAQs
                </h2>
                <div className="mt-4 max-w-lg">
                  <p className="text-white text-sm sm:text-base">
                    Find answers to the most commonly asked questions about our
                    services, features or how our bots can transform
                    your business.{" "}
                  </p>
                </div>
              </div>
              <div className="mb-6 h-full w-full text-white overflow-auto bg-gradient-to-bl from-[#7E35FB] via-[#7E35FB] to-[#B895F4] rounded-xl p-6">
                <div className="flex flex-row gap-4">
                  <img
                    src="avtar2.avif"
                    alt="Support"
                    className="inline-block h-12 w-12 object-cover rounded-full"
                  />
                  <div className="flex flex-col gap-1.5">
                    <h5 className="text-xl font-bold">Still have questions?</h5>
                    <div className="max-w-sm">
                      <p className="text-white text-sm sm:text-base">
                        Can’t find the answer you’re looking for? feel free to contact us.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mb-6 mt-8 h-[0.5px] w-full bg-white"></div>
                <a
                // onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                href="https://themksolution.com/contact/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block items-center rounded-md bg-black px-6 py-3 text-center font-semibold text-white">
                  Get In Touch 
                </a>
              </div>

              
            </div>
            <div className="lg:flex-[1_1_800px] w-full flex-none">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="mb-4 w-full overflow-hidden bg-[#1a1a1a] text-white px-8 py-4 rounded-lg"
                >
                  <div
                    className="flex cursor-pointer items-start justify-between"
                    onClick={() => toggleAccordion(index)}
                  >
                    <p className="text-md md:text-xl font-semibold">{faq.question}</p>
                    <div className="relative ml-10 mt-1 flex h-5 w-5 items-center justify-center">
                      <div
                        className={`absolute h-5 w-0.5 bg-white transform transition-transform ${
                          activeIndex === index ? "rotate-90" : ""
                        }`}
                      ></div>
                      <div className="h-0.5 w-5 bg-white"></div>
                    </div>
                  </div>
                  <div
                    ref={(el) => (contentRefs.current[index] = el)}
                    className="transition-all duration-500 ease-in-out overflow-hidden max-h-0"
                  >
                    <div className="mt-4">
                      <p className="text-sm sm:text-base">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Accordion;
